import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';

export const templateNetworkTreeContainer = document.createElement('template');

templateNetworkTreeContainer.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

<div class="wrapper">
    <gz-network-tree-search></gz-network-tree-search>
    <gz-loader class="tree-loader" rows="8"></gz-loader>
</div>
`;
